(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/ball-rows-collapsible/assets/javascripts/animations/core.js') >= 0) return;  svs.modules.push('/components/tur/ball-rows-collapsible/assets/javascripts/animations/core.js');

'use strict';

svs.tur = svs.tur || {};
svs.tur.ball = svs.tur.ball || {};
svs.tur.ball.rows = svs.tur.ball.rows || {};
svs.tur.ball.rows.collapsible = svs.tur.ball.rows.collapsible || {};
svs.tur.ball.rows.collapsible.animations = svs.tur.ball.rows.collapsible.animations || {};
class Core {
  constructor(rows) {
    this.rows = rows;
  }
}
svs.tur.ball.rows.collapsible.animations.Core = Core;

 })(window);